/**
 * This is used to hold information require by the API.
 * Due to issues with circular references when requiring modules
 * stores can't be required in actions and so this provides
 * another location for this information
 * @type {{token: string, userId:number, siteId: number, siteKey: string}}
 */
export default {
  token: null,
  userId: null,
  siteId: null,
  siteKey: null,
};
